"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PauseAdStatusOverlay = void 0;
var i18n_1 = require("../../localization/i18n");
var NonLinearAdEvents_1 = require("../../utils/NonLinearAdEvents");
var Button_1 = require("../buttons/Button");
var Container_1 = require("../Container");
var Label_1 = require("../labels/Label");
var PAUSE_AD_ACTIVE_CLASS = 'pause-ad-active';
/**
 * Player-sized click target for a pause ad rendered below the UI.
 * It supports pointer input only; visible controls remain above it and receive their own clicks.
 */
var PauseAdClickCatcher = /** @class */ (function (_super) {
    __extends(PauseAdClickCatcher, _super);
    function PauseAdClickCatcher(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, config) || this;
        _this.config = _this.mergeConfig(config, {
            cssClass: 'ui-pause-ad-click-catcher',
            buttonStyle: Button_1.ButtonStyle.Text,
            role: null,
            tabIndex: -1,
            hidden: true,
            acceptsTouchWithUiHidden: true,
        }, _this.config);
        // Base Button overrides must not turn this pointer-only target into a focusable control.
        _this.config.role = null;
        _this.config.tabIndex = -1;
        return _this;
    }
    PauseAdClickCatcher.prototype.toDomElement = function () {
        var element = _super.prototype.toDomElement.call(this);
        element.attr('aria-hidden', 'true');
        element.on('mousedown', function (event) { return event.preventDefault(); });
        return element;
    };
    return PauseAdClickCatcher;
}(Button_1.Button));
/**
 * An overlay holding status controls for pause ads.
 *
 * @category Components
 */
var PauseAdStatusOverlay = /** @class */ (function (_super) {
    __extends(PauseAdStatusOverlay, _super);
    function PauseAdStatusOverlay(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, config) || this;
        _this.handleNonLinearAdStarted = function (event) {
            var _a;
            if (!event.ad) {
                return;
            }
            _this.activePauseAd = event.ad;
            // Without a destination, clicks continue to reach the controls below.
            if (event.ad.clickThroughUrl) {
                _this.clickCatcher.show();
            }
            else {
                _this.clickCatcher.hide();
            }
            // Both controls have to be in their final state before the overlay becomes visible: showing the
            // overlay activates the pause-ad navigation group, which focuses the first component it finds
            // focusable at that moment.
            _this.dismissButton.show();
            _this.show();
            (_a = _this.uiContainerElement) === null || _a === void 0 ? void 0 : _a.addClass(_this.prefixCss(PAUSE_AD_ACTIVE_CLASS));
        };
        _this.handleNonLinearAdEnded = function (event) {
            var _a;
            if (!_this.activePauseAd) {
                return;
            }
            var eventAdId = (_a = event.ad) === null || _a === void 0 ? void 0 : _a.id;
            if (_this.activePauseAd.id && eventAdId && _this.activePauseAd.id !== eventAdId) {
                return;
            }
            _this.hidePauseAdStatus();
        };
        _this.hidePauseAdStatus = function () {
            var _a;
            _this.dismissButton.hide();
            _this.clickCatcher.hide();
            _this.activePauseAd = undefined;
            (_a = _this.uiContainerElement) === null || _a === void 0 ? void 0 : _a.removeClass(_this.prefixCss(PAUSE_AD_ACTIVE_CLASS));
            _this.hide();
        };
        _this.config = _this.mergeConfig(config, {
            hidden: true,
            cssClass: 'ui-pause-ad-status-overlay',
        }, _this.config);
        var badgeLabel = new Label_1.Label({
            cssClass: 'ui-pause-ad-status-badge',
            text: i18n_1.i18n.getLocalizer('ad'),
        });
        _this.clickCatcher = new PauseAdClickCatcher();
        _this.dismissButton = new Button_1.Button({
            cssClass: 'ui-button-pause-ad-dismiss',
            text: i18n_1.i18n.getLocalizer('close'),
            ariaLabel: i18n_1.i18n.getLocalizer('close'),
            buttonStyle: Button_1.ButtonStyle.TextWithTrailingIcon,
            hidden: true,
            acceptsTouchWithUiHidden: true,
        });
        // The catcher comes first so visible controls remain above it.
        _this.config.components = [_this.clickCatcher, badgeLabel, _this.dismissButton];
        return _this;
    }
    PauseAdStatusOverlay.prototype.configure = function (player, uimanager) {
        var _this = this;
        _super.prototype.configure.call(this, player, uimanager);
        this.uiContainerElement = uimanager.getUI().getDomElement();
        player.on(NonLinearAdEvents_1.NON_LINEAR_AD_STARTED_EVENT, this.handleNonLinearAdStarted);
        NonLinearAdEvents_1.NON_LINEAR_AD_ENDED_EVENTS.forEach(function (eventType) {
            player.on(eventType, _this.handleNonLinearAdEnded);
        });
        player.on(player.exports.PlayerEvent.SourceUnloaded, this.hidePauseAdStatus);
        this.clickCatcher.onClick.subscribe(function () {
            var _a;
            (_a = _this.getClickThroughAction()) === null || _a === void 0 ? void 0 : _a();
        });
        // The player may decline the skip, e.g. before the ad becomes dismissible, so the status stays
        // visible until the ad's terminal event arrives.
        this.dismissButton.onClick.subscribe(function () {
            player.ads.skip();
        });
    };
    PauseAdStatusOverlay.prototype.release = function () {
        this.hidePauseAdStatus();
        this.uiContainerElement = undefined;
        _super.prototype.release.call(this);
    };
    /**
     * Captures the active creative's click-through action for an external input surface.
     * Like linear ads (see `AdClickOverlay`), the action opens the destination and then reports it
     * through `clickThroughUrlOpened`, which only tracks the click.
     * The action becomes a no-op when this ad ends or is replaced, or this overlay becomes hidden.
     * Returns `undefined` when there is no click-through destination.
     */
    PauseAdStatusOverlay.prototype.getClickThroughAction = function () {
        var _this = this;
        var ad = this.activePauseAd;
        if (!(ad === null || ad === void 0 ? void 0 : ad.clickThroughUrl)) {
            return undefined;
        }
        return function () {
            var _a;
            if (_this.activePauseAd === ad && _this.isShown()) {
                window.open(ad.clickThroughUrl, '_blank');
                (_a = ad.clickThroughUrlOpened) === null || _a === void 0 ? void 0 : _a.call(ad);
            }
        };
    };
    return PauseAdStatusOverlay;
}(Container_1.Container));
exports.PauseAdStatusOverlay = PauseAdStatusOverlay;
